/**
 * Classer une erreur d'appel, pour que l'écran dise laquelle des trois c'est.
 *
 * LE DÉFAUT QUE CE MODULE FERME (lot I, item I3)
 *
 * Le 30/08, quatre écrans traitaient un refus de droits de quatre façons, et aucune
 * ne disait la vérité :
 *
 *   FacturationPage     `catch { setFactures([]) }`  ->  « Aucune facture émise »
 *   SymphonicsPage      `.catch(() => {})`           ->  rien du tout
 *   SurvoltagePage      un toast qui s'efface        ->  un écran vide derrière
 *   AggregateursPage    « Chargement impossible »    ->  une panne annoncée là où
 *                                                        il n'y a qu'un refus
 *
 * Trois situations, trois actions différentes pour l'utilisateur, donc TROIS MESSAGES
 * DISTINCTS et jamais un seul :
 *
 *   403 / 401   REFUS   « vous n'avez pas accès »   -> demander l'accès
 *   5xx, réseau ERREUR  « erreur »                  -> réessayer, appeler le support
 *   200 et []   VIDE    « aucune donnée »           -> il n'y a rien, tout va bien
 *
 * Confondre les trois coûte deux fois : on cherche une panne quand on s'est vu refuser
 * un accès, et on croit à un parc vide quand le serveur est tombé.
 */

export const REFUS = 'refus';
export const ERREUR = 'erreur';

/** Un refus de droits, ou une session expirée : dans les deux cas, ce n'est pas une
 *  panne, et l'utilisateur n'a pas à chercher ce qui est cassé. */
export function estUnRefus(erreur) {
  const statut = erreur?.response?.status;
  return statut === 403 || statut === 401;
}

/**
 * Le genre, le titre et le message destinés à l'écran.
 *
 * ⚠️ Le `detail` du serveur n'est PAS repris sur un 403 : il vaut « Acces refuse »,
 * qui est une réponse d'API et non une phrase pour un humain.
 */
export function classerErreur(erreur) {
  const statut = erreur?.response?.status;

  if (statut === 403) {
    return {
      genre: REFUS,
      titre: "Vous n'avez pas accès à cet écran",
      message: "Votre profil ne donne pas accès à ces données. "
        + "Demandez l'accès à l'administrateur de votre espace.",
    };
  }

  if (statut === 401) {
    return {
      genre: REFUS,
      titre: 'Votre session a expiré',
      message: 'Reconnectez-vous pour continuer.',
    };
  }

  // Aucune réponse du tout : la requête n'est jamais arrivée. Le dire évite de
  // chercher un droit manquant pendant une coupure réseau.
  if (!erreur?.response) {
    return {
      genre: ERREUR,
      titre: 'Le serveur ne répond pas',
      message: 'Vérifiez votre connexion, puis réessayez.',
    };
  }

  const detail = erreur.response?.data?.detail;
  return {
    genre: ERREUR,
    titre: 'Erreur de chargement',
    message: typeof detail === 'string' && detail
      ? detail
      : `Le serveur a répondu ${statut}. Réessayez dans un instant.`,
  };
}
